import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 2rem;
`

export const Message = styled.div`
  font-size: 1.5rem;
  color: #666;
  font-family: 'Inter', sans-serif;
`
